export default __webpack_public_path__ + "static/media/sig-2.46cebd7d.jpg";